export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST'
export const PRODUCT_SUCCESS = 'PRODUCT_SUCCESS'
export const PACKAGE_SUCCESS = 'PACKAGE_SUCCESS'
export const PRODUCT_ERROR = 'PRODUCT_ERROR'